// @flow
import {
    ASSET_LIST,
    ASSET_LIST_SUCCESS,
    ASSET_LIST_FAILED,
    ASSET_ADD,
    ASSET_ADD_SUCCESS,
    ASSET_ADD_FAILED,
    ASSET_UPDATE,
    ASSET_UPDATE_SUCCESS,
    ASSET_UPDATE_FAILED,
    ASSET_DELETE,
    ASSET_DELETE_SUCCESS,
    ASSET_DELETE_FAILED
} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

const INIT_STATE = {
    user: getLoggedInUser(),
    loading: false,
};

type AssetAction = { type: string, payload: {} | string };
type State = { user?: {} | null, loading?: boolean, +value ?: boolean };

const Asset = (state: State = INIT_STATE, action: AssetAction) => {
    switch (action.type) {
        case ASSET_LIST:
            return { ...state, assetloading: true };
        case ASSET_LIST_SUCCESS:
            return { ...state, asset: action.payload, assetloading: false, error: null };
        case ASSET_LIST_FAILED:
            return { ...state, error: action.payload, loading: false };
        case ASSET_ADD:
            return { ...state, loading: true };
        case ASSET_ADD_SUCCESS:
            return { ...state, assetAdd: action.payload, loading: false, error: null };
        case ASSET_ADD_FAILED:
            return { ...state, error: action.payload, loading: false };
        case ASSET_UPDATE:
            return { ...state, loading: true };
        case ASSET_UPDATE_SUCCESS:
            return { ...state, assetUpdate: action.payload, loading: false, error: null };
        case ASSET_UPDATE_FAILED:
            return { ...state, error: action.payload, loading: false };
        case ASSET_DELETE:
            return { ...state, loading: true };
        case ASSET_DELETE_SUCCESS:
            return { ...state, assetDelete: action.payload, loading: false, error: null };
        case ASSET_DELETE_FAILED:
            return { ...state, error: action.payload, loading: false };
        default:
            return { ...state };
    }
};

export default Asset;

